module.exports = __webpack_public_path__ + "static/img/btn-msgz.d7106e2d.png";